import React from 'react';
import styled from 'styled-components';

interface StarColorItemProps {
  color: string;
  available: boolean;
  selected: boolean;
  width?: string;
  height?: string;
}

const getSelectedStyles = (selected?: boolean, strokeColor?: string) => {
  const _styles = {
    stroke: '#F0A0BF',
    strokeWidth: '2',
  };

  const _strokeStyle = {
    stroke: strokeColor,
    strokeWidth: '2',
    strokeOpacity: 1,
  };

  return strokeColor && !selected ? _strokeStyle : selected ? _styles : {};
};

export const StarColorItem: React.FC<StarColorItemProps> = ({
  color,
  available,
  selected,
  width = '45px',
  height = '45px',
}) => {
  const colors = color.split('/').map((c) => `#${c}`);
  const gradientId = `star-gradient-${color.replaceAll('/', '-')}`;

  const getGradientStops = () => {
    const step = 100 / colors.length;
    return colors.flatMap((c, i) => [
      <stop key={`${c}-${i}-start`} offset={`${i * step}%`} stopColor={c} />,
      <stop
        key={`${c}-${i}-end`}
        offset={`${(i + 1) * step}%`}
        stopColor={c}
      />,
    ]);
  };

  return (
    // <SvgContainer width={width} height={height}>
    <StyledSvg
      width="40"
      height="40"
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      available={available}
      selected={selected}
    >
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="0">
          {getGradientStops()}
        </linearGradient>
      </defs>
      <path
        d="M9.47309 32.9822C9.1272 33.9823 8.82855 35.045 8.53771 36.0799C8.45597 36.3708 8.37485 36.6595 8.29347 36.944L8.2912 36.9519L8.28906 36.9599C8.12648 37.5658 7.9698 38.2395 7.88332 38.9415L7.88238 38.9491L7.88156 38.9567C7.79498 39.7611 7.87068 40.5069 8.22806 41.1015C8.61449 41.7445 9.22915 42.0472 9.85025 42.1235C10.4337 42.1952 11.0367 42.0745 11.569 41.8947C12.1084 41.7125 12.6469 41.4451 13.1365 41.1458C14.7582 40.2204 16.3202 39.2068 17.8806 38.1512L17.8834 38.1493C18.8188 37.5118 19.705 36.9164 20.6322 36.5905L20.6323 36.5905L20.6405 36.5875C20.7401 36.5515 20.8453 36.5209 20.9516 36.4953L21.2837 36.4594C22.5729 36.3204 23.8501 36.9899 25.3169 37.9617L25.3209 37.9643C27.251 39.2301 29.2057 40.4686 31.1707 41.6924L31.1764 41.6959L31.1985 41.7095C31.7072 42.0217 32.7274 42.6477 33.6998 42.8878C34.19 43.0089 34.8514 43.0807 35.4636 42.7816C36.147 42.4478 36.5001 41.7938 36.6104 41.0403L36.6159 41.0029L36.6185 40.9651C36.6752 40.1518 36.5315 39.3742 36.3452 38.6772C36.2321 38.2543 36.0826 37.7952 35.9465 37.3771C35.8711 37.1456 35.7999 36.9267 35.7411 36.7333L35.7398 36.7292C35.5975 36.2681 35.4557 35.8078 35.314 35.348C34.8067 33.7017 34.3012 32.0609 33.7799 30.405C33.7553 30.3224 33.731 30.2412 33.7072 30.1614C33.4116 29.1732 33.1789 28.3952 33.3103 27.6435C33.4563 26.8898 34.1018 26.275 35.0215 25.5245C35.4981 25.1413 35.9705 24.7612 36.4404 24.3831C37.6589 23.4026 38.8606 22.4356 40.0763 21.4616L40.0763 21.4616L40.0828 21.4563C40.1425 21.4077 40.2102 21.3533 40.2843 21.2938C40.8581 20.8333 41.8166 20.0641 42.3994 19.2462C42.727 18.7864 43.0718 18.1303 42.9847 17.3845C42.8947 16.6143 42.3904 16.0532 41.712 15.6723L41.6461 15.6068L41.458 15.5312C40.2872 15.0605 39.0118 15.0541 37.9703 15.0489C37.7829 15.048 37.603 15.0471 37.4327 15.0435L37.4222 15.0433H37.4118H37.4058C36.4614 15.0433 35.5023 15.0433 34.5153 15.0691C34.378 15.0676 34.2417 15.0666 34.1063 15.0655C33.0557 15.0572 32.0648 15.0493 31.1809 14.8436C30.231 14.6225 29.5485 14.2038 29.1466 13.3824L29.142 13.3728L29.1371 13.3634C28.3988 11.932 27.9601 10.3656 27.5721 8.69468C27.4777 8.28797 27.3856 7.87145 27.2923 7.44917C27.0105 6.17454 26.7172 4.84745 26.3121 3.57923L26.3059 3.56009L26.2991 3.54121C25.9968 2.7115 25.6067 2.02959 25.0914 1.57811C24.5354 1.09095 23.8494 0.89392 23.1444 1.06788C22.5031 1.22611 21.9801 1.6583 21.5779 2.13607C21.1669 2.62433 20.8118 3.24245 20.5205 3.92716C19.5944 6.01941 18.7344 8.12182 17.8764 10.2198C17.7964 10.4151 17.7165 10.6105 17.6366 10.8058L17.6296 10.823L17.6232 10.8404C16.9383 12.7088 16.2254 14.0748 14.8391 14.4872L14.8182 14.4934L14.7977 14.5005C12.8604 15.1697 10.7788 15.0972 8.54527 15.018L8.51304 15.0168L8.4808 15.0177C8.16172 15.027 7.77428 15.0135 7.30994 14.9972C7.18134 14.9927 7.04684 14.988 6.90626 14.9835C6.28408 14.9637 5.57642 14.9502 4.88588 14.9987C4.20263 15.0466 3.47429 15.1586 2.82854 15.4222C2.17079 15.6907 1.53699 16.1441 1.17637 16.8978L1.14739 16.9584L1.12677 17.0223C0.749158 18.1923 1.27933 19.155 1.81302 19.7931C2.18382 20.2364 2.69587 20.6747 3.06335 20.9894C3.18802 21.0961 3.29604 21.1886 3.37627 21.2622L3.39466 21.279L3.41387 21.295C3.76315 21.5847 4.11192 21.8734 4.46029 22.1619C5.84854 23.3113 7.23054 24.4555 8.61347 25.6335C8.9312 25.9131 9.25347 26.2208 9.55652 26.522L9.55653 26.522L9.57809 26.5434C10.0491 27.0241 10.3309 27.4037 10.4686 27.8333C10.6817 28.5575 10.6251 29.342 10.4029 30.2241C10.2423 30.8613 10.0211 31.4664 9.78688 32.1069C9.68344 32.3898 9.57747 32.6796 9.47309 32.9822ZM9.47309 32.9822C9.47305 32.9823 9.47301 32.9824 9.47297 32.9825L10.4183 33.3087L9.47323 32.9818C9.47318 32.9819 9.47314 32.9821 9.47309 32.9822Z"
        fill={`url(#${gradientId})`}
        vectorEffect="non-scaling-stroke"
        {...getSelectedStyles(selected)}
      />
    </StyledSvg>
    // </SvgContainer>
  );
};

const SvgContainer = styled.div<{ width: string; height: string }>`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
`;

const StyledSvg = styled.svg<{ available?: boolean; selected?: boolean }>`
  width: 45px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  stroke-width: 1px;
  ${({ available, selected }) =>
    available &&
    !selected &&
    `
    &:hover  {
      scale: 0.9;
    }`}

  ${({ available }) => !available && `cursor: not-allowed;`}
`;
